import Sprite = PIXI.Sprite;
import Text = PIXI.Text;
import { createSprite } from '../utils/GameEngine';
import { TextStyles } from '../utils/TextStyles';
import { AbstractPopUp, AbstractPopUpParams } from './AbstractPopUp';
import { PopUpName } from '../core/managers/PopUpManager';
import { Button } from '../UI/elements/buttons/Button';

export interface MessagePopUpParams extends AbstractPopUpParams {
  message: string;
  hideTimeout?: number;
}

export class MessagePopUp extends AbstractPopUp {
  private timeout: any;
  private hidden: boolean;

  constructor(public readonly name: PopUpName, params: MessagePopUpParams) {
    super(name, {
      message: params.message,
      hideTimout: params.hideTimeout,
      noCloseButton: true,
      noBackground: true,
      onCloseCallback: params.onCloseCallback
    } as MessagePopUpParams);

    if (params.hideTimeout) {
      this.timeout = setTimeout(() => {
        if (!this.hidden) {
          this.hide();
        }
      }, params.hideTimeout * 1000);
    }
  }

  protected drawLayout(params?: MessagePopUpParams): void {
    const background: Sprite = createSprite('win_challenge_background', this);
    const title: Text = new Text('NO ACTION NEEDED', TextStyles.smallTextWhite);
    const text: Text = new Text(params.message, TextStyles.smallParagraphText);
    title.anchor.set(0.5, 0.5);
    text.anchor.set(0.5, 0.5);
    title.x = background.width / 2;
    text.x = background.width / 2;
    title.y = 20;
    text.y = 75;
    this.addChild(title);
    this.addChild(text);
    const closeButton: Button = new Button('green_btn_small@2x', this.hide.bind(this), 'OK');
    this.addChild(closeButton);
    closeButton.x = background.width / 2;
    closeButton.y = background.height;
  }

  public destroy(options?: { children?: boolean; texture?: boolean; baseTexture?: boolean }): void {
    clearTimeout(this.timeout);
    super.destroy(options);
  }

  public show(keepQueue: boolean = false): void {
    this.hidden = false;
    super.show(keepQueue);
  }

  public hide(quick: boolean = false): void {
    super.hide(quick);
    this.hidden = true;
  }
}